module.exports = __webpack_public_path__ + "../resources/img/ic_re_pvmodule.0c297f29.svg";